<template>
  <div class="vld-parent">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>
    <div class="table-responsive" v-if="totalData != 0">
      <table
        class="table table-centered table-striped table-bordered table-nowrap mb-0"
      >
        <thead class="thead-dark">
          <tr>
            <template
              v-if="table_module == 'blog' || table_module == 'troubleshoot'"
            >
              <th style="width: 20px">
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="checkboxSelectAll"
                    @click="selectAll"
                    v-model="allSelected"
                  />
                  <label class="custom-control-label" for="checkboxSelectAll"
                    >&nbsp;</label
                  >
                </div>
              </th>
            </template>
            <template v-else>
              <template v-if="local_users.usr_admin != ''">
                <th
                  style="width: 20px"
                  v-if="
                    table_module != 'admin' &&
                    table_module != 'customers' &&
                    hiddenCheckbox != false
                  "
                >
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="checkboxSelectAll"
                      @click="selectAll"
                      v-model="allSelected"
                    />
                    <label class="custom-control-label" for="checkboxSelectAll"
                      >&nbsp;</label
                    >
                  </div>
                </th>
              </template>
            </template>
            <th
              style="width: 70px"
              v-if="
                ACL.edit == true || ACL.delete == true || ACL.detail == true
              "
            ></th>
            <th v-for="(item, index) in fields" :key="index">
              <div
                @click="
                  sortAction(item[alias_table + '_f_name'], sortable.sort)
                "
                class="d-flex align-items-center justify-content-between"
                style="cursor: pointer"
              >
                {{ item[alias_table + "_f_label"] }}
                <template
                  v-if="sortable.orderBy == item[alias_table + '_f_name']"
                >
                  <template v-if="sortable.sort == 'asc'">
                    <i class="bx bx-sort-a-z"></i>
                  </template>
                  <template v-else>
                    <i class="bx bx-sort-z-a"></i>
                  </template>
                </template>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data['data']" :key="index">
            <template
              v-if="table_module == 'blog' || table_module == 'troubleshoot'"
            >
              <td>
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    :id="'checkbox_' + item[alias_table + '_id']"
                    class="custom-control-input"
                    v-model="massData"
                    @click="select"
                    :value="item[alias_table + '_uuid']"
                    true-value="yes"
                    false-value="no"
                  />
                  <label
                    class="custom-control-label"
                    :for="'checkbox_' + item[alias_table + '_id']"
                    >&nbsp;</label
                  >
                </div>
              </td>
            </template>
            <template v-else>
              <template v-if="local_users.usr_admin != ''">
                <td
                  v-if="
                    table_module != 'admin' &&
                    table_module != 'customers' &&
                    hiddenCheckbox != false
                  "
                >
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      :id="'checkbox_' + item[alias_table + '_id']"
                      class="custom-control-input"
                      v-model="massData"
                      @click="select"
                      :value="item[alias_table + '_uuid']"
                      true-value="yes"
                      false-value="no"
                    />
                    <label
                      class="custom-control-label"
                      :for="'checkbox_' + item[alias_table + '_id']"
                      >&nbsp;</label
                    >
                  </div>
                </td>
              </template>
            </template>
            <td
              v-if="
                ACL.edit == true || ACL.delete == true || ACL.detail == true
              "
            >
              <template
                v-if="table_module == 'blog' || table_module == 'troubleshoot'"
              >
                <button
                  v-if="ACL.edit == true"
                  @click="edit(item[alias_table + '_uuid'])"
                  type="button"
                  class="btn btn-link btn-rounded waves-effect"
                >
                  <i class="bx bx-edit-alt"></i>
                </button>
                <button
                  v-if="ACL.delete == true"
                  @click="showAlert(item[alias_table + '_uuid'])"
                  type="button"
                  class="btn btn-link btn-rounded waves-effect"
                >
                  <i class="bx bx-trash"></i>
                </button>
              </template>
              <template v-else>
                <template v-if="local_users.usr_admin != ''">
                  <button
                    v-if="ACL.edit == true"
                    @click="edit(item[alias_table + '_uuid'])"
                    type="button"
                    class="btn btn-link btn-rounded waves-effect"
                  >
                    <i class="bx bx-edit-alt"></i>
                  </button>
                  <button
                    v-if="ACL.delete == true"
                    @click="showAlert(item[alias_table + '_uuid'])"
                    type="button"
                    class="btn btn-link btn-rounded waves-effect"
                  >
                    <i class="bx bx-trash"></i>
                  </button>
                </template>
              </template>
              <button
                v-if="ACL.detail == true"
                type="button"
                class="btn btn-link btn-rounded waves-effect"
                @click="detail(item[alias_table + '_uuid'])"
              >
                <i class="fa fa-info" aria-hidden="true"></i>
              </button>
              <button
                v-if="table_module == 'services_transaction'"
                class="btn btn-link btn-rounded waves-effect"
                @click="invoice(item[alias_table + '_uuid'])"
                :to="{ name: table_module + '/invoice' }"
              >
                <i class="bx bxs-report"></i>
              </button>
            </td>
            <td
              v-for="(item_fields, index_fields) in fields"
              :key="index_fields"
              :class="
                item_fields[alias_table + '_f_name'] == 'crs_model_id' ||
                item_fields[alias_table + '_f_name'] == 'prd_id' ||
                item_fields[alias_table + '_f_name'] == 'srv_b_description' ||
                item_fields[alias_table + '_f_name'] == 'ts_keluhan' ||
                item_fields[alias_table + '_f_name'] == 'ts_tindakan'
                  ? 'specifictd'
                  : ''
              "
            >
              <template
                v-if="item_fields[alias_table + '_f_name'] == 'crs_brand_id'"
              >
                <template v-if="Array.isArray(item.crs_brand_id)">
                  <router-link
                    v-for="(x, y) in item[item_fields[alias_table + '_f_name']]"
                    :key="y + '_crs_brand_id'"
                    class="mr-1"
                    target="_blank"
                    :to="{
                      name: 'cars_brand_detail',
                      params: { uuid: x['crs_brand_uuid'] },
                    }"
                    >{{ x.crs_brand_name }}
                    {{
                      item[item_fields[alias_table + "_f_name"]].length != y + 1
                        ? ", "
                        : ""
                    }}</router-link
                  >
                </template>
                <template v-else>
                  <router-link
                    :to="{
                      name: 'cars_brand_detail',
                      params: { uuid: item['crs_brand_uuid'] },
                    }"
                    >{{ item["crs_brand_name"] }}</router-link
                  >
                </template>
              </template>
              <template
                v-else-if="
                  item_fields[alias_table + '_f_name'] == 'crs_model_id'
                "
              >
                <template v-if="Array.isArray(item.crs_model_id)">
                  <router-link
                    v-for="(x, y) in item[item_fields[alias_table + '_f_name']]"
                    :key="y + '_crs_model_id'"
                    class="mr-1"
                    target="_blank"
                    :to="{
                      name: 'cars_model_detail',
                      params: { uuid: x['crs_model_uuid'] },
                    }"
                    >{{ x.crs_model_name }}
                    {{
                      item[item_fields[alias_table + "_f_name"]].length != y + 1
                        ? ", "
                        : ""
                    }}</router-link
                  >
                </template>
                <template v-else>
                  <router-link
                    :to="{
                      name: 'cars_model_detail',
                      params: { uuid: item['crs_model_uuid'] },
                    }"
                    >{{ item["crs_model_name"] }}</router-link
                  >
                </template>
              </template>
              <template
                v-else-if="item_fields[alias_table + '_f_name'] == 'srv_t_type'"
                >{{ item["srv_t_type_name"] }}</template
              >
               <template
                v-else-if="item_fields[alias_table + '_f_name'] == 'emp_payroll_type'"
                >{{ item["emp_payroll_type_name"] }}</template
              >
              <template
                v-else-if="item_fields[alias_table + '_f_name'] == 'usr_id'"
                >{{ item["usr_fullname"] }}</template
              >
              <template
                v-else-if="item_fields[alias_table + '_f_name'] == 'srv_t_cat'"
                >{{ item["srv_t_cat_name"] }}</template
              >
              <template
                v-else-if="
                  item_fields[alias_table + '_f_name'] == 'srv_t_status'
                "
              >
                <template v-if="item.srv_t_status == 3">
                  <h5 style="text-transform: uppercase">
                    <span class="badge badge-primary p-2">
                      {{ item["srv_t_status_name"] }}
                    </span>
                  </h5>
                </template>
                <template v-else-if="item.srv_t_status == 4">
                  <h5 style="text-transform: uppercase">
                    <span class="badge badge-dark p-2">
                      {{ item["srv_t_status_name"] }}
                    </span>
                  </h5>
                </template>
                <template v-else-if="item.srv_t_status == 1">
                  <h5 style="text-transform: uppercase">
                    <span class="badge badge-secondary p-2">
                      {{ item["srv_t_status_name"] }}
                    </span>
                  </h5>
                </template>
                <template v-else-if="item.srv_t_status == 9">
                  <h5 style="text-transform: uppercase">
                    <span class="badge badge-danger p-2">
                      {{ item["srv_t_status_name"] }}
                    </span>
                  </h5>
                </template>
                <template v-else-if="item.srv_t_status == 0">
                  <h5 style="text-transform: uppercase">
                    <span class="badge badge-warning p-2">
                      {{ item["srv_t_status_name"] }}
                    </span>
                  </h5>
                </template>
                <template v-else-if="item.srv_t_status == 2">
                  <h5 style="text-transform: uppercase">
                    <span class="badge badge-success p-2">
                      {{ item["srv_t_status_name"] }}
                    </span>
                  </h5>
                </template>
                <template v-else>
                  {{ item["srv_t_status_name"] }}
                </template>
              </template>
              <template
                v-else-if="item_fields[alias_table + '_f_name'] == 'brd_id'"
                >{{ item["brd_name"] }}</template
              >
              <template
                v-else-if="item_fields[alias_table + '_f_name'] == 'prd_c_id'"
                >{{ item["prd_c_name"] }}</template
              >
              <template
                v-else-if="
                  item_fields[alias_table + '_f_name'] == 'srv_id' &&
                  table_module == 'services_bulk'
                "
              >
                <router-link
                  v-for="(x, y) in item[item_fields[alias_table + '_f_name']]"
                  :key="y"
                  class="mr-1"
                  target="_blank"
                  :to="{ name: 'services' }"
                  >{{ x.srv_name }}
                  {{
                    item[item_fields[alias_table + "_f_name"]].length != y + 1
                      ? ", "
                      : ""
                  }}</router-link
                >
              </template>
              <template
                v-else-if="
                  item_fields[alias_table + '_f_input_type'] == 'option' &&
                  (item[item_fields[alias_table + '_f_name'] + '_label'] != undefined || item[item_fields[alias_table + '_f_name'] + '_name'] != undefined)
                "
              >
                {{ item[item_fields[alias_table + '_f_name'] + '_label'] || item[item_fields[alias_table + '_f_name'] + '_name'] }}
              </template>
              <template
                v-else-if="
                  item_fields[alias_table + '_f_input_type'] == 'radio' &&
                  (item[item_fields[alias_table + '_f_name'] + '_label'] != undefined || item[item_fields[alias_table + '_f_name'] + '_name'] != undefined)
                "
              >
                <span
                  class="badge"
                  :class="item[item_fields[alias_table + '_f_name']] == '1' || item[item_fields[alias_table + '_f_name']] == 'yes' ? 'badge-success' : 'badge-secondary'"
                >{{ item[item_fields[alias_table + '_f_name'] + '_label'] || item[item_fields[alias_table + '_f_name'] + '_name'] }}</span>
              </template>
              <template
                v-else-if="
                  item_fields[alias_table + '_f_input_type'] == 'datetime' || item_fields[alias_table + '_f_input_type'] == 'date'
                "
              >
                <template v-if="item[item_fields[alias_table + '_f_name']]">
                  {{ $moment(item[item_fields[alias_table + '_f_name']]).format('DD MMM YYYY HH:mm') }}
                </template>
              </template>
              <template
                v-else-if="
                  item_fields[alias_table + '_f_name'] == 'prd_id' &&
                  table_module == 'services_bulk'
                "
              >
                <router-link
                  v-for="(x, y) in item[item_fields[alias_table + '_f_name']]"
                  :key="y"
                  class="mr-1"
                  target="_blank"
                  :to="{
                    name: 'products_detail',
                    params: { uuid: x['prd_uuid'] },
                  }"
                >
                  {{ x.prd_name }}
                  {{
                    item[item_fields[alias_table + "_f_name"]].length != y + 1
                      ? ", "
                      : ""
                  }}</router-link
                >
              </template>
              <template
                v-else-if="
                  item_fields[alias_table + '_f_input_type'] == 'money'
                "
              >
                <template v-if="item.prd_discount_active && item_fields[alias_table + '_f_name'] == 'prd_purchase'">
                  <s class="text-muted small">Rp {{ numberWithCommas(item.prd_purchase) }}</s>
                  <span class="text-danger font-weight-bold ml-1">Rp {{ numberWithCommas(item.prd_effective_price) }}</span>
                </template>
                <template v-else>
                  {{ item[item_fields[alias_table + "_f_name"]] != null ? "Rp " + numberWithCommas(item[item_fields[alias_table + "_f_name"]]) : "" }}
                </template>
              </template>
              <template v-else>{{ item[item_fields[alias_table + "_f_name"]] }}</template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="d-flex align-items-center w-100 bg-light mb-3 h-350" v-else>
      <div class="m-auto text-center mini-stats-wid">
        <div
          class="mini-stat-icon avatar-sm rounded-circle bg-secondary m-auto"
        >
          <span class="avatar-title">
            <i class="bx bx-search-alt font-size-2"></i>
          </span>
        </div>
        <h5 class="mt-3">Data Empty</h5>
        <p class="mb-0">Please create new your data</p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-5">Anda memiliki {{ $root.numberWithCommas(data.total_data) }} data</div>
      <template v-if="data.total_page != 0">
        <paginate
          v-model="page"
          :pageCount="parseInt(data.total_page)"
          :initial-page="page"
          :click-handler="startPaginate"
          prevText="<i class='mdi mdi-chevron-left'></i>"
          nextText="<i class='mdi mdi-chevron-right'></i>"
          container-class="pagination pagination-rounded justify-content-end col-md-7"
          pageClass="page-item"
          page-link-class="page-link"
          prev-class="page-item"
          prev-link-class="page-link"
          next-class="page-item"
          next-link-class="page-link"
        ></paginate>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fields: {
      type: [Object, Array],
      required: true,
    },
    data: {
      type: [Object, Array],
      required: true,
    },
    module: {
      type: String,
      required: true,
    },
    table_module: {
      type: String,
      required: true,
    },
    alias_table: {
      type: String,
      required: true,
    },
    hiddenCheckbox: {
      type: Boolean,
      default: true,
    },
    local_users:{
      type: Object,
      // Object or array defaults must be returned from
      // a factory function
      default: function () {
        return {};
      },
    },
    sortable: {
      type: Object,
      // Object or array defaults must be returned from
      // a factory function
      default: function () {
        return { orderBy: "created_at", sort: "desc" };
      },
    },
    ACL: {
      type: Object,
      // Object or array defaults must be returned from
      // a factory function
      default: function () {
        return { edit: true, delete: true, detail: true };
      },
    },
  },
  data() {
    return {
      allSelected: false,
      massData: [],
      page: 1,
      limit: 15,
      totalData: 0,
    };
  },
  computed: {
    isLoading() {
      if (this.fields.length > 0) {
        return false;
      }

      return true;
    },    
  },
  mounted() {
    this.limit = this.data.show;
    this.page = this.data.current_page;
    this.totalData = this.data.total_data;
  },
  watch: {
    data: function (newVal) {
      this.limit = newVal.show;
      this.page = newVal.current_page;
      this.totalData = newVal.total_data;
    },
  },
  methods: {
    edit(uuid = "") {
      this.$router.push({
        name: this.table_module + "_edit",
        params: { uuid: uuid },
        // query: {
        //   page: this.page,
        //   limit: this.limit,
        //   orderBy: this.sortable.orderBy,
        //   sort: this.sortable.sort,
        // },
      });
    },
    invoice(uuid = "") {
      this.$router.push({
        name: this.table_module + "_invoice",
        params: { uuid: uuid },
      });
    },
    detail(uuid = "") {
      this.$router.push({
        name: this.table_module + "_detail",
        params: { uuid: uuid },
      });
    },
    showAlert(uuid = "") {
      // Use sweetalert2
      var Swal = this.$swal;
      Swal.fire({
        title: "Yakin ingin hapus?",
        // text: "You will not be able to recover this imaginary file!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then((result) => {
        if (result.value) {
          if (
            this.table_module == "admin" ||
            this.table_module == "customers"
          ) {
            this.axios
              .post("/users/deletebyAdmin/" + uuid, this.post)
              .then((response) => {
                if (response.data.status == 200) {
                  this.$emit("fetchData", {
                    page: this.page,
                    limit: this.limit,
                    orderBy: this.sortable.orderBy,
                    sort: this.sortable.sort,
                  });
                }
              });
          } else {
            this.axios
              .post("/" + this.table_module + "/delete/" + uuid, this.post)
              .then((response) => {
                if (response.data.status == 200) {
                  this.$emit("fetchData", {
                    page: this.page,
                    limit: this.limit,
                    orderBy: this.sortable.orderBy,
                    sort: this.sortable.sort,
                  });
                }
              });
          }
          // https://sweetalert2.github.io/#handling-dismissals
        } else if (result.dismiss) {
          // Swal.fire("Cancelled", "Hapus dibatalkan", "error");
        }
      });
    },
    selectAll: function () {
      this.massData = [];
      this.$emit("massDelete");
      if (this.allSelected == false) {
        for (var key in this.data["data"]) {
          this.massData.push(
            this.data["data"][key][this.alias_table + "_uuid"].toString()
          );
          this.$emit(
            "massDelete",
            this.data["data"][key][this.alias_table + "_uuid"].toString()
          );
        }
      }
      // if (this.allSelected == false) {
      //   for (var key in this.data["data"]) {
      //     this.massData.push(
      //       this.data["data"][key][this.alias_table + "_uuid"].toString()
      //     );
      //   }
      // }
    },
    select(event) {
      this.allSelected = false;
      if (event.target.checked) {
        this.$emit("massDelete", event.target.value);
      } else {
        this.$emit("uncheckMassDelete", event.target.value);
      }
      // for (var key in this.data["data"]) {
      //   this.$emit(
      //     "massDelete",
      //     this.data["data"][key][this.alias_table + "_uuid"].toString()
      //   );
      // }
    },
    startPaginate: function (pageNum) {
      this.massData = []; // reset mass data
      this.allSelected = false;

      var arm = {
        page: pageNum,
        show: parseInt(this.limit),
      };
      this.$emit("fetchData", arm);
    },
    numberWithCommas(arm) {
      if (arm != "" && arm != null) {
        return arm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return 0;
    },
    randclass() {
      var rand = Math.floor(Math.random() * 5) + 1;
      var style = "badge-outline-primary";
      if (rand == 2) {
        style = "badge-outline-danger";
      } else if (rand == 3) {
        style = "badge-outline-success";
      } else if (rand == 4) {
        style = "badge-outline-info";
      } else if (rand == 5) {
        style = "badge-outline-warning";
      } else {
        style = "badge-outline-primary";
      }

      return style;
    },
    sortAction(name, sort) {
      var trueSort = sort == "asc" ? "desc" : "asc";
      this.$set(this.sortable, "orderBy", name);
      this.$set(this.sortable, "sort", trueSort);
      this.$emit("fetchData", {
        orderBy: name,
        sort: trueSort,
      });
    },
  },
};
</script>

<style>
.specifictd {
  white-space: normal !important;
  word-wrap: break-word;
  min-width: 400px;
}
</style>